export function formatAverage(value: number | string | null | undefined) {
  if (value === null || value === undefined || value === '') return 'Novo'

  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) return String(value)

  return `${numericValue.toFixed(1)} ★`
}

export function formatVerificationLevel(level?: string) {
  if (!level) return 'Nepreverjeno'

  return level
    .replaceAll('_', ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
}

export function formatRegion(regionCode?: string) {
  if (!regionCode) return 'Regija ni označena'

  return regionCode
    .replaceAll('-', ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
}
